import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

const SIMPLIFIED_UI_CONFIG_HTML_ATTRIBUTE = 'simplified' as const;
const FROM_INTERNAL_SITE_HTML_ATTRIBUTE = 'from-internal-site' as const;
const EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE =
  'express-branding-settings' as const;
const DOCSITE_USER_SESSION_KEY_HTML_ATTRIBUTE =
  'docsite-user-session-key' as const;
const DOCSITE_ACCOUNT_ID_HTML_ATTRIBUTE = 'docsite-account-id' as const;
const DOCSITE_LIVEMODE_HTML_ATTRIBUTE = 'docsite-livemode' as const;

export const DebugUIConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "debugUIConfig" */ '../../../components/Debug/UIConfig/UIConfig'
    ),
  releaseState: 'internal',
  ignoreThemingValues: true,
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  htmlAttributes: {
    // Internal - to enable these for platforms, we'll need API review
    [SIMPLIFIED_UI_CONFIG_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [FROM_INTERNAL_SITE_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    // The following three attributes are set by the docsite and carry the
    // logged-in user's session key, the currently selected merchant's account
    // ID, and whether that merchant is in livemode (true = livemode, omitted/false = sandbox). They are
    // passed directly to the theme token generator endpoint
    // (POST /v1/embedded/theme_extractor) so that single request is
    // authenticated as the docsite user acting on the selected merchant.
    // We intentionally do NOT use metaOptions for these values because we
    // still want the rest of Connect Embedded to call from the perspective of
    // our demo platform using the ephemeral key (EK).
    [DOCSITE_USER_SESSION_KEY_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [DOCSITE_ACCOUNT_ID_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
    [DOCSITE_LIVEMODE_HTML_ATTRIBUTE]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setOnLoginNeeded: {
      type: 'EventListenerMethod',
      event: 'loginneeded',
      isInternal: true,
      description:
        'Sets the callback to invoke when the user needs to log in (e.g. to use the theme extractor).',
    },
    setExpressBrandingSettings: {
      type: 'AttributeSettingMethod',
      attribute: EXPRESS_BRANDING_SETTINGS_HTML_ATTRIBUTE,
      isInternal: true,
      description:
        'When `true`, this means the component is being rendered in the standard dashboard in the Express branding drawer.',
    },
  },
  description:
    'Allows for configuring theming in Connect embedded components. Used in the Stripe doc site for the theming demo, and for theming the Express dashboard from the Stripe Dashboard.',
  friendlyName: 'Debug UI config',
};
